export default "__VITE_ASSET__7c7d39c0__"